import React from 'react';
import { fetch_data } from './Data';

type LoadDataProps = {
  dataset: string,
  type: string,
  component: any,
  n_shards: number,
};

type LoadDataState = {
  data: any | null,
};

export default class LoadDataComponent extends React.Component<LoadDataProps, LoadDataState> {
  constructor(props: LoadDataProps) {
    super(props);

    this.state = {
      data: null,
    };
  }

  componentDidUpdate(prevProps: LoadDataProps) {
    if (this.props.dataset !== prevProps.dataset) {
      console.log('Data changed!');
      this.setState({ data: null })
      this.update_data()
    }
  }

  async update_data() {
    let orig_type = this.props.type;
    const data = (await fetch_data(this.props.type, this.props.dataset, this.props.n_shards)).results;
    if (this.props.type !== orig_type) {
      console.log('changed type')
      return;
    }
    this.setState({
      data: data,
    });
  }

  async componentDidMount() {
    this.update_data()
  }

  render() {
    const SubComponent = this.props.component;

    console.log('data', this.state.data)
    if (this.state.data === null) {
      return 'Loading...';
    }
    return (
      <SubComponent
        data={this.state.data}
        dataset={this.props.dataset}
      />
    );
  }
}
